import { Injectable } from '@angular/core';
import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(private api: ApiService, private util: UtilService) { }

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }

  get refreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  get userId(): number {
    return parseInt(localStorage.getItem('UserId'));
  }

  get userRoleId(): number {
    return parseInt(localStorage.getItem('UserRoleId'));
  }
  get orgID(): string | null {
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  /**
   * Account Login
   */
  login(data: any) {
    const [latitude, longitude] = this.util.clientGeoLocation.split(',');
    const postData: APIRequest = {

      requestBody: {
        ...data,
        browser: this.util.clientBrowser,
        ipaddress: this.util.clientIPAddr,
        latitude,
        longitude,
      },
    };
    return this.api.post(URL.ACCOUNT.LOGIN, postData);
  }

  /**
   * Account Logout
   */
  logout() {
    const postData: APIRequest = {

      requestBody: {
        sessionId: localStorage.getItem('loginSessionId') || this.jwt,
        userId: this.userId,
      },
    };

    return this.api.post(URL.ACCOUNT.LOGOUT, postData);
  }

  /**
   * Forgot Password
   */
  forgotPassword(emailId: string, orgId?: string) {
    const postData: APIRequest = {

      requestBody: {
        emailId: emailId,
        orgId: orgId,
      },
    };

    return this.api.post(URL.ACCOUNT.FORGOT_PWD, postData);
  }

  getOrgForPass(emailId: string) {
    const postData: APIRequest = {
      requestBody: {
        emailId: emailId,
      },
    };

    return this.api.post(URL.ACCOUNT.GET_ORG_FOR_PASS, postData);
  }

  /**
   * Reset Password
   */
  resetPassword(encId: string, password: string, confirmPassword: string, orgId: string | null) {
    const postData: APIRequest = {

      requestBody: {
        encId,
        password,
        confirmPassword,
        orgId
      },
    };

    return this.api.post(URL.ACCOUNT.RESET_PWD, postData);
  }

  /**
   * Reset Password with User ID and Org ID
   */
  resetPasswordWithIds(userId: string, orgId: string, password: string, confirmPassword: string) {
    const postData: APIRequest = {

      requestBody: {
        userId,
        orgId,
        password,
        confirmPassword
      },
    };

    return this.api.post(URL.ACCOUNT.RESET_PWD, postData);
  }

  /**
   * Reset Password with Email and Org ID
   */
  resetPasswordWithEmail(email: string, orgId: string, password: string, confirmPassword: string) {
    const postData: APIRequest = {

      requestBody: {
        email,
        orgId,
        password,
        confirmPassword
      },
    };
    return this.api.post(URL.ACCOUNT.RESET_PWD, postData);
  }

  /**
   * Save User Privacy Consent
   */
  saveConsent() {
    const postData: APIRequest = {
      requestBody: {}
    };
    return this.api.post(URL.ACCOUNT.SAVE_CONSENT, postData);
  }

  /**
   * Change Password
   */
  changePassword(currentPassword: string, newPassword: string) {
    const postData: APIRequest = {

      requestBody: {
        currentPassword,
        newPassword,
      },
    };

    return this.api.post(URL.ACCOUNT.CHANGE_PWD, postData);
  }

  /**
   * get Menus
   */
  getMenus() {
    return this.api.get(URL.ACCOUNT.MENU);
  }

  /**
   * get User Org List
   */
  getUserOrgList(data: any) {
    const [latitude, longitude] = this.util.clientGeoLocation.split(',');
    const postData: APIRequest = {

      requestBody: {
        ...data,
        browser: this.util.clientBrowser,
        ipaddress: this.util.clientIPAddr,
        latitude,
        longitude,
      },
    };

    return this.api.post(URL.ACCOUNT.GET_USER_ORG_LIST, postData);
  }

  getSubscribedFeatures(data: any) {
    const [latitude, longitude] = this.util.clientGeoLocation.split(',');
    const postData: APIRequest = {

      requestBody: {
        ...data,
        browser: this.util.clientBrowser,
        ipaddress: this.util.clientIPAddr,
        latitude,
        longitude,
      },
    };

    return this.api.post(URL.ACCOUNT.GET_SUBSCRIBED_FEATURES_BY_ORG_ID, postData);
  }

  isSystemSuperAdmin(data: any) {
    const [latitude, longitude] = this.util.clientGeoLocation.split(',');
    const postData: APIRequest = {

      requestBody: {
        ...data,
        browser: this.util.clientBrowser,
        ipaddress: this.util.clientIPAddr,
        latitude,
        longitude,
      },
    };

    return this.api.post(URL.ACCOUNT.IS_SYSTEM_SUPER_ADMIN, postData);
  }

  /**
   * Account Login with Orgnization
   */
  loginWithOrg(data: any) {
    const [latitude, longitude] = this.util.clientGeoLocation.split(',');
    const postData: APIRequest = {

      requestBody: {
        ...data,
        browser: this.util.clientBrowser,
        ipaddress: this.util.clientIPAddr,
        latitude,
        longitude,
      },
    };

    return this.api.post(URL.ACCOUNT.LOGIN_WITH_ORG, postData);
  }

  getUserOrgId() {
    return this.orgID;
  }
}
